import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "list",
  "use": "list-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 13\" id=\"list\"><path fill=\"var(--bolt-theme-icon, currentColor)\" d=\"M3.3 9.8V13H0V9.7h3.3zm9.7.8v1.6H4.9v-1.6H13zM3.2 4.9V8H0V5h3.3zm9.8.8v1.6H4.9V5.7H13zM3.2 0v3.3H0V0h3.3zm9.8.8v1.6H4.9V.8H13z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol